export const getLastFixtureForCup = (matches, cupId, cupYear) => {
  const allCupMatches = matches.filter(
    match => match.cupId === cupId &&
    match.competitionYear === cupYear
  )
  allCupMatches.sort((a, b) => a.kickOff > b.kickOff ? -1 : 1)
  return allCupMatches[0]
}
